import 'twin.macro';
import 'styled-components/macro';

import { Placeholder } from 'component-lib/molecules/placeholder/Placeholder';

export const EmptyLabPlaceholder = () => {
  return (
    <Placeholder
      tw="bg-blue-darkest text-white w-full rounded-none"
      title="You don’t have any tabs yet..."
      description="Add websites or products for users to interact with."
    />
  );
};
